import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LanguageSwitcher } from "@/components/ui/language-switcher";
import { useLanguage } from "@/contexts/language-context";

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
      <div className="container mx-auto flex h-16 items-center justify-between px-4">
        <Link to="/" className="flex items-center space-x-2">
          <img src="/纯logo无文字.png" alt="Logo" className="h-10 w-auto" />
          <span className="font-bold text-xl">{t("header.siteName")}</span>
        </Link>

        <nav className="hidden md:flex items-center space-x-6">
          <Link
            to="/"
            className="text-sm font-medium transition-colors hover:text-blue-600"
          >
            {t("nav.home")}
          </Link>
          <Link
            to="/products"
            className="text-sm font-medium transition-colors hover:text-blue-600"
          >
            {t("nav.vehicles")}
          </Link>
          <Link
            to="/about"
            className="text-sm font-medium transition-colors hover:text-blue-600"
          >
            {t("nav.about")}
          </Link>
          <Link
            to="/blog"
            className="text-sm font-medium transition-colors hover:text-blue-600"
          >
            {t("nav.blog")}
          </Link>
          <Link
            to="/contact"
            className="text-sm font-medium transition-colors hover:text-blue-600"
          >
            {t("nav.contact")}
          </Link>
        </nav>

        <div className="hidden md:flex items-center space-x-4">
          <LanguageSwitcher />
          <Link to="/contact">
            <Button>{t("common.bookTestDrive")}</Button>
          </Link>
        </div>

        <button
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {isMenuOpen && (
        <div className="md:hidden border-t bg-white">
          <nav className="container mx-auto flex flex-col space-y-4 px-4 py-4">
            <Link
              to="/"
              className="text-sm font-medium transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              {t("nav.home")}
            </Link>
            <Link
              to="/products"
              className="text-sm font-medium transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              {t("nav.vehicles")}
            </Link>
            <Link
              to="/about"
              className="text-sm font-medium transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              {t("nav.about")}
            </Link>
            <Link
              to="/blog"
              className="text-sm font-medium transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              {t("nav.blog")}
            </Link>
            <Link
              to="/contact"
              className="text-sm font-medium transition-colors hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              {t("nav.contact")}
            </Link>
            <div className="pt-2">
              <LanguageSwitcher />
            </div>
            <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
              <Button className="w-full">{t("common.bookTestDrive")}</Button>
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}